import React, { useContext } from 'react';
import { ElementViewBuilderContext } from 'core/context';
import { ElementViewBuilderConfig } from 'core/ElementViewBuilder';
import TableTextAction from '../TableTextAction';

const PaycutPaymentsAction = ({ paycutId }) => {
	const { setElementView } = useContext(ElementViewBuilderContext);

	const handleOpenPayments = event => {
		event.stopPropagation();
		const elementViewKeys =
			ElementViewBuilderConfig.getAuthorizedElementViewKeys();

		setElementView({
			elementViewKey:
				elementViewKeys.BILLING_PAYMENT_PAYCUT_DETAILS_REQUEST_ELEMENT,
			elementId: paycutId,
			isInvoice: false,
		});
	};

	return (
		<TableTextAction
			type='button'
			onClick={handleOpenPayments}
			aria-label={`Ver pagos del corte ${paycutId}`}
		>
			Ver pagos
		</TableTextAction>
	);
};

export default PaycutPaymentsAction;
